export default __webpack_public_path__ + "static/media/prize1.4f50d362.svg";